import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  type: z.enum(['applicants', 'contacts']).optional()
})

export const Route = createFileRoute('/_dashboard/tempo/import')({
  validateSearch: searchSchema
})
